<div class="section padding-top-120 padding-top-mob-nav section-background-rana-3">
    <div class="section-1400 padding-top-40">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-sm-10 col-md-8 col-lg-6 align-self-center pr-lg-4 pr-xl-5 text-center text-lg-left pb-5 pb-lg-0 mb-4 mb-lg-0">
                    <h6 class="color-primary text-uppercase mb-2">
                        Rajput Community Medical Assistance Program
                    </h6>
                    <h3 class="display-8 mb-4">
                        <span class="font-weight-600">Connecting you with Rajput doctors</span><br/>
                        <span class="title-line-bottom font-weight-700">for free medical advice and opinions</span>
                    </h3>
                    <p class="lead mb-5">
                        At RANA, we believe in the well-being of every member. Our program connects Rajput doctors with
                        in the community, offering free medical advice for those seeking help or opinions on medical
                        conditions.
                    </p>
                    <p class="lead mb-5">
                        Whether you need a second opinion, basic medical advice, or help navigating a health issue. The
                        doctors with in the community specialize in a variety of fields, ensuring that you receive
                        informed and reliable advice.
                    </p>
                </div>
                <div class="col-sm-10 col-md-8 col-lg-6 img-wrap1 align-self-center pl-lg-4 pl-xl-5">
                    <div class="row">
                        <div class="col-12">
                            <div class="image-container">
                                <img src="../../assets/img/dr.jpg"/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="section padding-top-120 padding-top-mob-nav section-background-rana-medical-2">
    <div class="section-1400">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <!-- Text Section -->
                <div class="col-sm-10 col-md-8 col-lg-6 align-self-center pr-lg-4 pr-xl-5 text-center text-lg-right pb-5 pb-lg-0 mb-4 mb-lg-0">
                    <h6 class="color-primary text-uppercase mb-2">How It Works</h6>
                    <h3 class="display-8 mb-4">Simple and easy access to medical advice</h3>
                    <p class="lead mb-5">
                        Our process is simple: fill out the request form, and we'll connect you with a doctor for your
                        free consultation.
                    </p>
                </div>

                <!-- Content Cards Section -->
                <div class="col-sm-10 col-md-8 col-lg-6 img-wrap align-self-center pl-lg-4 pl-xl-5">
                    <div class="row">
                        <!-- Card 1: Top -->
                        <div class="col-12 mb-4" data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                            <div class="section border-4 services-wrap-3 bg-red p-4">
                                <h5 class="mb-3">Fill Out the Request Form</h5>
                                <p class="mb-0 text-left">
                                    Share your medical concern in the form provided, including any relevant details for
                                    better advice.
                                </p>
                            </div>
                        </div>

                        <!-- Card 2: Middle -->
                        <div class="col-12 mb-4" data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                            <div class="section border-4 services-wrap-3 bg-blue p-4">
                                <h5 class="mb-1">Get Connected with a Doctor</h5>
                                <p class="mb-3">
                                    Our executive committee will forward your request to a Rajput doctor, who will
                                    contact you for further discussion.
                                </p>
                            </div>
                        </div>

                        <!-- Card 3: Bottom -->
                        <div class="col-12 mb-4" data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                            <div class="section border-4 services-wrap-3 bg-teal p-4">
                                <h5 class="mb-1">Receive Your Free Medical Advice</h5>
                                <p class="mb-3">
                                    Get the guidance you need—whether it's a second opinion or general advice—straight
                                    from a trusted doctor.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="section padding-top-120 padding-top-mob-nav section-background-rana-medical-3">
    <div class="section-1400">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="">
                    <h6 class="color-primary text-uppercase mb-2">Disclaimer</h6>
                    <p class="lead mb-5">
                        The medical advice provided by Rajput doctors in this program is general in nature and should
                        not be considered as a substitute for in-person consultations with healthcare professionals.
                        Always seek professional medical help when necessary.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
